import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HiMenu } from 'react-icons/hi';

import logoAr from 'src/assets/images/navbar/logo_ar.webp';
import logoEn from 'src/assets/images/navbar/logo_en.webp';

import { isRTL } from 'src/utils/global';
import styles from './styles.module.css';



import { Link as ScrollLink } from "react-scroll";
import { FaPhoneVolume } from "react-icons/fa6";


const ICON_SIZE = 22;

const NavSmall = () => {
    const { t, i18n } = useTranslation("common");
    const [show, setShow] = useState<boolean>(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getLinkClassName = `${styles.item__link} nav-link`;

    // ✅ Dynamically select logo based on language
    const currentLang = i18n.language;
    const logo =
        currentLang === 'ar'
            ? logoAr
            : logoEn;

    return (
        <header>
            <Navbar expand={false} className={`${styles.nav} ${styles.nav__sm} ${isRTL() && styles.rtl}`}>
                <Container>
                    {/* Logo */}
                    <Navbar.Brand className={styles.nav_brand} href="/">
                        <img src={logo} alt={t("nav.title")} className={styles.logo_img} />
                    </Navbar.Brand>

                    {/* Hamburger Toggle */}
                    <Navbar.Toggle
                        className={styles.toggle}
                        aria-controls="offcanvasNavbar-expand-xl"
                        onClick={handleShow}
                    >
                        <HiMenu size={ICON_SIZE + 4} />
                    </Navbar.Toggle>

                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-xl"
                        aria-labelledby="offcanvasNavbarLabel-expand-xl"
                        placement={isRTL() ? "start" : "end"}
                        show={show}
                        onHide={handleClose}
                        className={`${styles.sm__offcanvas} ${isRTL() && styles.rtl__offcanvas}`}
                    >
                        <Offcanvas.Header closeButton className={styles.offcanvas__header}>
                            <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                                <img src={logo} alt={t("title")} height={50} width={123} />
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body className={styles.offcanvas__body}>
                            <Nav className="justify-content-end flex-grow-1">
                                <Link
                                    to="/"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                >
                                    {t("nav.home")}
                                </Link>

                                <ScrollLink
                                    to="aboutUs"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                    smooth={true}
                                    duration={500}
                                >
                                    {t("nav.about")}
                                </ScrollLink>

                                <ScrollLink
                                    to="services"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                    smooth={true}
                                    duration={500}
                                >
                                    {t("nav.services")}
                                </ScrollLink>

                                <ScrollLink
                                    to="gallery"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                    smooth={true}
                                    duration={500}
                                >
                                    {t("nav.gallery")}
                                </ScrollLink>

                                <ScrollLink
                                    to="whyUs"
                                    onClick={handleClose}
                                    className={getLinkClassName}
                                    smooth={true}
                                    duration={500}
                                >
                                    {t("nav.whyUs")}
                                </ScrollLink>

                                <div className={styles.contactWrapper}>
                                    <a href="https://wa.me/218912100092"
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.contactButton}>
                                        <FaPhoneVolume />
                                    </a>
                                </div>

                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            <div className={styles.prop}></div>
        </header>
    );
}

export default NavSmall;
